import {AppPageElementType} from './app.page.element.type';
import {AppPageValidates} from './app.page.validates';
import {AppElementSelectItem} from './app.element.selectitem';
import {AppPageRelationships } from './app.page.relationships';
import {AppElementInfo} from './app.element.info';
/**
 * 当前模块所包含的控件模块，相当于xml的Element节点
 */
export class AppPageElement {
    constructor() {
        this.readonly = false;
        this.selectItemList = new AppElementSelectItem();
        this.badgeCount = 0;
        this.employLimit=null;
        this.coverType=null;

    }
     /**
     * 控件类型
     */
    type: AppPageElementType = AppPageElementType.Text;
    /**
     * 模块名称
     */
    name: string;
    /**
     * 控件的名称，相当于xml对应的modal名称
     */
    field: string;
    /**
     * 必填
     */
    required: boolean;
    /**
     * 图标
     */
    icon: string;
    /**
     * 整体模块样式
     */
    class: string;
    /**
     * 填写的默认解释行文字
     */
    placeholder: string;
    /**
     * 默认值
     */
    defaultval: string;
    /**
     * 是否显示(针对type=“tabs”)
     */
    showTab: boolean;
    /**
     * 最小值
     */
    min: string;
    /**
     * 最大值
     */
    max: string;
    /**
     * 控件输入的小数位数
     */
    decimallength: number;
    /**
     * 设置是否多选
     */
    multiple: boolean;
    /**
     * 文件类型,数组类型(Array); 默认为:[“xlxs”,” docx”,”zip”,”..”]
     */
    extensionType: string;
    /**
     * 上传文件大小限制，单位为kb
     */
    fileSizeLimit: number;
    /**
     * 默认为"YYYY-MM-DD ",格式化展示格式,可配置参数为”YYYY”,”MM”,”DD”,”HH”,”SS”
     */
    displayformat: string;
    /**
     * 动态加载数据的api地址
     */
    dataApiUrl: string;
    /**
     * 错误提示消息
     */
    validates: AppPageValidates;
    /**
     * SelectItemList
     */
    selectItemList: AppElementSelectItem;
    /**
     * relationships
     */
    relationships: AppPageRelationships;
    /**
     * elementInfo
     */
    elementInfo: AppElementInfo;
    /**
     * 显示标记
     */
    showBadge: boolean;
    /**
     * 标记字符,纯数字,为零则表示初始值
     */
    badgeCount:number;
    /**
     * 不可编辑
     */
    readonly: boolean;
    /**
     * xml返回的类型，针对按钮样式
     */
    htmlType:boolean;
    /**
     * 采集点控件处理方式；none：无限制,work :上班才可以操作
     */
    employLimit:any;
    /**
     * 采集点数据覆盖方式,默认为none,day"当天覆盖式添加数据",month"按月覆盖式添加数据"
     */
    coverType:any;
    /**
     * url
     */
    url: string;
}